import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { PlanRateMatrix } from "@/components/features/items/plan-rate-matrix/ui";

import { useGetPlanRateMatrixPageParams } from "./_hooks/use-get-plan-rate-matrix-page-params";

export const PlanRateMatrixPage = () => {
	const { hotelID } = useGetPlanRateMatrixPageParams();

	return (
		<PageMeta title="料金一覧" url={generatePath(PATHS.HOTEL.ITEMS.PLAN.RATE_MATRIX, { hotelID })}>
			<PlanRateMatrix hotelID={hotelID} />
		</PageMeta>
	);
};

PlanRateMatrixPage.displayName = "PlanRateMatrixPage";
